import request from '@/utils/request'

// 获取供应商列表
export function getList(params) {
  return request.get('/supplier/list', { params })
}

// 创建供应商信息
export function createOne(data) {
  return request.post('/supplier/create', data)
}

// 更新供应商信息
export function updateOne(data) {
  return request.post('/supplier/update', data)
}

// 删除供应商信息
export function deleteOne(data) {
  const url = '/supplier/delete/' + data.id
  return request.get(url)
}

// 创建人员预约信息
export function createManOrderInfo(data) {
  return request.post('/personOrder/create', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取预约列表
export function getManOrderList(data) {
  const { start, end, ...params } = data
  return request.get('/personOrder/list', {
    params: {
      ...params,
      startDate: start,
      endDate: end,
    }
  })
}

// 人员预约审核
export function updateManOrderStatus(data) {
  const { id, ...params } = data
  const url = '/personOrder/check/' + id
  return request.get(url, {
    params
  })
}

// 创建货车预约信息
export function createTruckOrderInfo(data) {
  return request.post('/truckOrder/create', data)
}

// 获取预约列表
export function getTruckOrderList(data) {
  const { start, end, ...params } = data
  return request.get('/truckOrder/list', {
    params: {
      ...params,
      startDate: start,
      endDate: end
    }
  })
}

// 货车预约审核
export function updateTruckOrderStatus(data) {
  const { id, ...params } = data
  const url = '/truckOrder/check/' + id
  return request.get(url, { params })
}

// 删除预约信息
export function deleteOrderInfo(data) {
  const url = '/truckOrder/delete/' + data.id
  return request.get(url)
}

// 获取预约列表
export function getOrderList(params) {
  return request.get('/truckOrder/history', { params })
}

// 获取访问列表
export function getAccessList(params) {
  return request.get('/truckAccess/history', { params })
}

// 获取过磅列表
export function getWeighBridgeList(params) {
  return request.get('/weighbridge/history', { params })
}

// 获取灌料列表
export function getMaterialCheckList(params) {
  return request.get('/dualCheck/history', { params })
}


// 获取消息推送列表
export function getProjectConfigList(data) {
  return request.get('/projectConfig/list')
}

// 获取货车道闸列表
export function getAggregateTruckStay(data) {
  return request.get('/truckAccess/exitCar')
}
